module.exports = __webpack_public_path__ + "img/logo_u1992-19.8b75a479.svg";